/**
 * Filters out articles that are not available in a specific branch office.
 *
 * @param {Array} articles - The array of articles to filter.
 * @param {string} branchId - The ID of the branch office.
 * @returns {Array} - The filtered array of articles.
 */
export const filterOutArticlesNotAvailableInBranchOffice = (articles, branchId) => {
  articles = articles.filter((article) => {
    return !article.notAvailableInBranchOffices.some((office) => office._ref === `branchOffice-${branchId}`)
  })
  return articles
}
